(function(window, viewHelperDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.viewHelper = viewHelperDefinition(
      window,
      window.document,
      window.$,
      namespace.highlightDisabler);
})(this, function(window, document, $, highlightDisabler) {
   'use strict';

   var _previousActiveElement;
   var _previousActiveElementWasHighlighted;
   var _$window = $(window);

   var scrollActiveElementIntoView = function() {
      try {
         var activeElement = document.activeElement;
         if (activeElement) {
            scrollIntoView(activeElement);
         }
      } catch (e) {
         /* eslint  no-empty:'off' */
      }
   };

   var scrollIntoView = function(e) {
      setTimeout(function() {
         var element = e.currentTarget ? e.currentTarget : e;
         var container = $(element).scrollParent();

         if (!element || !container || !element.scrollIntoViewIfNeeded) {
            return;
         }

         // Android uses container innerHeight while ios uses window innerHeight
         var elementFitsInsideContainer = element.offsetHeight <= container.innerHeight() && element.offsetHeight < window.innerHeight;
         element.scrollIntoViewIfNeeded(elementFitsInsideContainer);
      }, 200);
   };

   var saveActiveElement = function() {
      try {
         _previousActiveElement = document.activeElement;
         _previousActiveElementWasHighlighted = highlightDisabler.checkIfElementIsHighlighted($(document.activeElement));
      } catch (e) {
         /* eslint  no-empty:'off' */
      }
   };

   var disableHighlightsOnPreviousActiveElement = function() {
      if (_previousActiveElement) {
         var $previousActiveElement = $(_previousActiveElement);
         if (!_previousActiveElementWasHighlighted) {
            highlightDisabler.disableHighlights($previousActiveElement);
         }
      }
   };

   var focusPreviousElement = function() {
      if (_previousActiveElement) {
         var $previousActiveElement = $(_previousActiveElement);
         $previousActiveElement.focus();
         disableHighlightsOnPreviousActiveElement();
      }
   };

   var elementOrChildHasFocus = function($element) {
      try {
         return $element.is(':focus') || $element.has(document.activeElement).length > 0;
      } catch (e) {
         return false;
      }
   };

   var init = function() {
      _$window.blur(saveActiveElement).focus(disableHighlightsOnPreviousActiveElement);
   };

   init();

   return {
      scrollActiveElementIntoView: scrollActiveElementIntoView,
      scrollIntoView: scrollIntoView,
      saveActiveElement: saveActiveElement,
      focusPreviousElement: focusPreviousElement,
      elementOrChildHasFocus: elementOrChildHasFocus
   };
});
